<template>
  <div v-if="isActive"
       class="timeline-selection"
       :style="styles"
  >
    <div class="timeline-selection__arrow"></div>
  </div>
</template>

<script>
export default {
  name: "TimelineSelection",
  props: {
    beforeYear: {
      type: Number,
      default: null
    },
    startYear: {
      type: Number,
      default: null
    }
  },
  computed: {
    isActive() {
      return this.beforeYear !== null
    },
    yearsCount() {
      return this.beforeYear - this.startYear || 0
    },

    styles() {
      return {
        height: `${ this.yearsCount * 10.8 + 5 }px`
      }
    }
  }
}
</script>

<style lang="scss">
$selection-color: rgba($app-primary-accent-color, .5);
$arrow-color: rgba($app-primary-accent-color, .8);

.timeline-selection {
  position: absolute;
  top: 0;
  left: calc(50% + 2px);
  width: 10px;
  background-color: $selection-color;
  transform: translateY(40px);
  pointer-events: none;
  transition: height .15s;

  &__arrow {
    position: absolute;
    bottom: 0;
    left: -10px;
    width: 7px;
    height: 10px;
    background-color: $arrow-color;
    transform: translate(-100%, 50%);

    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(100%);
      width: 10px;

      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-left: 6px solid $arrow-color;
    }

  }

}
</style>